export default __webpack_public_path__ + "static/media/ic_play_circle_outline_24px.6e36dd7b.svg";